import ContentSection, { ContentSectionHeader, ContentSectionProps } from '../ContentSection';
import styles from './styles/PhotosCalloutModule.module.scss';
import { ReactNode } from 'react';
import Clickable from '../Clickable';

export default function PhotosCalloutModule({
  title,
  right,
  topText,
  photoGalleries,
  footer,
  ...props
}: Omit<ContentSectionProps, 'children'> & {
  title: string;
  right?: ReactNode;
  topText?: ReactNode;
  photoGalleries: {
    name: string;
    coverPhoto: {
      s3Watermark: string | undefined;
      watermark: string;
    };
    webPath: string;
    thumbnailUrl: string | undefined;
  }[];
  footer?: ReactNode;
}) {
  return (
    <ContentSection {...props}>
      <ContentSectionHeader right={right}>{title}</ContentSectionHeader>
      <div className={styles.Container}>
        <div className={styles.TopText}>{topText}</div>
        <div className={styles.CoverPhotosContainer}>
          {photoGalleries.slice(0, 3).map((gallery, index) => (
            <Clickable key={`${gallery.name}-${index}`} href={gallery.webPath}>
              <div
                style={{
                  backgroundImage: `url(${gallery.thumbnailUrl ?? gallery.coverPhoto.s3Watermark ?? gallery.coverPhoto.watermark})`
                }}
                className={styles.CoverPhoto}
              />
            </Clickable>
          ))}
        </div>
      </div>
      {footer && <div className={styles.Footer}>{footer}</div>}
    </ContentSection>
  );
}
